/**
 * @file index.tsx
 *
 * @fileoverview Generic error to be displayed when an error boundary is triggerd in the main App.
 */

import React from 'react';
import AppGenericError from '~/jobiqo/components/AppGenericError';
import * as Sentry from '@sentry/nextjs';

export const ErrorPage = () => {
  return <AppGenericError />;
};
ErrorPage.getInitialProps = async (contextData) => {
  // In case this is running in a serverless function, await this in order to give Sentry
  // time to send the error before the lambda exits
  await Sentry.captureUnderscoreErrorException(contextData);
  // This will contain the status code of the response
  const statusCode = contextData.res?.statusCode;
  return { statusCode };
};

export default ErrorPage;
